var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowModal)?_c('portal',{attrs:{"to":"modals"}},[_c('b-modal',{attrs:{"size":"lg","hide-footer":""},model:{value:(_vm.shouldShowModal),callback:function ($$v) {_vm.shouldShowModal=$$v},expression:"shouldShowModal"}},[_c('document-form',{attrs:{"id":_vm.file.id},on:{"documentUpdated":_vm.documentUpdated}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }